// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffc27f55","455":"985f8fc9","977":"b44fed13"}[chunkId] + ".chunk.js";
};